import React from 'react';

/**
 * Bloc période de paie avec heures et congés
 */
export function PeriodBlock({ year, month, hours, leaves = {} }) {
  const monthNames = [
    'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
    'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
  ];

  const totalLeaves = (leaves.paid || 0) + (leaves.unpaid || 0) + (leaves.sick || 0);

  return (
    <div className="payroll-period-block">
      <div className="payroll-period-info">
        <div className="payroll-period-item">
          <span className="payroll-label">Période :</span>
          <span className="payroll-value">{monthNames[month - 1]} {year}</span>
        </div>
        <div className="payroll-period-item">
          <span className="payroll-label">Heures :</span>
          <span className="payroll-value">{hours ? hours.toFixed(2) : '0.00'}h</span>
        </div>
        {totalLeaves > 0 && (
          <div className="payroll-period-item">
            <span className="payroll-label">Congés :</span>
            <span className="payroll-value">
              {leaves.paid > 0 && `${leaves.paid}j CP`}
              {leaves.unpaid > 0 && ` ${leaves.unpaid}j SS`}
              {leaves.sick > 0 && ` ${leaves.sick}j maladie`}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}